import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { AircraftRepository } from 'domain/repositories/IAircraftRepository';
import { ID } from 'domain/types/ID';
import { useHookInjection } from 'application/hooks';

import { QUERY_PREFIX } from './useCaseSearchAircraft';

export const useCaseSetAircraftActive = () => {
  const qClient = useQueryClient();
  const { setAircraftActive: setActive } = useHookInjection<AircraftRepository>(AircraftRepository);

  const setAircraftActive = useCallback(
    async (id: ID, isActive: boolean) => {
      await setActive(id, isActive);
      await qClient.invalidateQueries({ queryKey: [QUERY_PREFIX] });
    },
    [setActive, qClient],
  );

  return { setAircraftActive };
};
